import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

// components
import { SbSharedRefineMenuRadioSelectList } from '../SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelectList.jsx';

const SbSharedRefineMenuFilterItemTypeComponent = props => (
    <SbSharedRefineMenuRadioSelectList {...props} />
);

export const SbSharedRefineMenuFilterItemType = createFragmentContainer(
    SbSharedRefineMenuFilterItemTypeComponent,
    {
        itemSearch: graphql`
            fragment SbSharedRefineMenuFilterItemType_itemSearch on ItemSearchQueryConnection {
                ...SbSharedRefineMenuRadioSelectList_itemSearch
            }
        `,
    }
);
